import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  expires: [],
  filters: {
    page: 1,
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.emisores.expires = {
      ...state.app.emisores.expires,
      ...data,
    };
  });
};

const expires = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.emisores.expires.busy = true;
  });

  try {
    const params = {
      status: 'expire',
    };

    const response = await Http.get('api/emisores', { params });

    store.setState((state) => {
      state.app.emisores.expires.busy = false;
      state.app.emisores.expires.data = response.data;
      state.app.emisores.expires = {
        ...state.app.emisores.expires,
        pagination: {
          ...state.app.emisores.expires.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.expires.busy = false;
      state.app.emisores.expires.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.emisores.expires = { ...initialState };
  });
};

const EmisorExpiresStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    expires,
    reset,
  },
};

export default EmisorExpiresStore;
